export class Context {
	public constructor(
		public property: string,
		public value: string | number
	) {}
}
